import { render, staticRenderFns } from "./tenant-panel.vue?vue&type=template&id=b2aea236"
import script from "./tenant-panel.vue?vue&type=script&lang=ts"
export * from "./tenant-panel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports